import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { SETTINGS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LimitTypeListPage } from '@/features/limitTypes/pages/LimitTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/limit-types')({
  beforeLoad: () => requirePermission(SETTINGS_PERMISSIONS.LIMIT_TYPES_EDIT),
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Limit Types">
      <Suspense fallback={<PageLoader />}>
        <LimitTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
